<template>
    <router-view name="pageTitle"></router-view>
</template>

<script>
export default {
    name: "BlankTitle"
}
</script>